"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadRequestError = void 0;
const client_library_1 = require("@seneca/client-library");
class BadRequestError extends client_library_1.ExtendableError {
    constructor(field, message) {
        super(`${field} failed validation. ${message}`);
        this.field = field;
    }
}
exports.BadRequestError = BadRequestError;
//# sourceMappingURL=BadRequestError.js.map